import React from "react";
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import TextBox from './Components/TextBox.jsx';

const ChangePasswordForm = ({ onSubmit,oldPassword }) => {
	let T = window.Texts.login;

	let initValues = {
		password: '',
		password2: '',
		oldPassword:''
	};
	let validationSchema = Yup.object({
		oldPassword: oldPassword? Yup.string().required(T.required) : Yup.string(),
		password: Yup.string()
			.required(T.required)
			.min(8, 'Minimální délka hesla je 8 znaků'),
		password2: Yup.string()
			.oneOf(
				[Yup.ref('password')],
				'Hesla nesouhlasí',
			)
			.required('Required')
	});

	let submit = (values, actions) => {
		onSubmit(values, actions);
	};

	return (
		<Formik initialValues={initValues} validationSchema={validationSchema} onSubmit={(values, actions) => submit(values, actions)} >
			{props => (
				<Form autoComplete="off">
					{props.errors.general ?
						<div>
							<p className="missing-entry">
								<strong>{props.errors.general}</strong>
							</p>
						</div> : null}
					<div>

						<div className="form-group" style={{ display: (oldPassword) ? 'block' : 'none' }} >
							<TextBox type="password" name="oldPassword" required="true" label={T.currentPassword} placeholder={T.currentPassword} key="oldpassword2" />
						</div>
						<div className="form-group">
							<TextBox type="password" name="password" required="true" label={T.newPassword} placeholder={T.newPassword + ':'} key="oldpassword" />
						</div>
						<div className="form-group">
							<TextBox type="password" name="password2" required="true" label={T.newPasswordConfirm} placeholder={T.newPasswordConfirm + ':'} key="newpassword" />
						</div>
						<div className="buttons">
							<button className="btn btn50 iconed icon-continue"><span>{T.confirmBtn}</span></button>
						</div>
					</div>
				</Form>)}
		</Formik>);
};
export default ChangePasswordForm;
